import { render, staticRenderFns } from "./GroupActivities.vue?vue&type=template&id=d9897b28&scoped=true&"
import script from "./GroupActivities.vue?vue&type=script&lang=js&"
export * from "./GroupActivities.vue?vue&type=script&lang=js&"
import style0 from "./GroupActivities.vue?vue&type=style&index=0&id=d9897b28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9897b28",
  null
  
)

export default component.exports